<div class="users-container" id="users-container">
  <ng-container>
    <h1 class="mb-5 mt-5-m">{{ "COMMON.CART" | translate }}:</h1>

    <h3 *ngIf="cart?.items?.length === 0">{{ "TRANSACTIONS.REQUESTED_TRANSACTION_DOES_NOT_EXIST" | translate }}.</h3>

    <form class="user-form" *ngIf="cart" [formGroup]="userProfileForm">
      <div formArrayName="items">
        <div class="user" *ngFor="let cartItem of cart.items; let i = index" [formGroupName]="i">
          <div class="cart-user-info w-100 mb-2" data-name="sbr">
            <span class="user-title">{{ "TICKETS.TICKET" | translate }} {{ i + 1 }} - {{ "TICKETS.SECTOR" | translate }}: {{ cartItem.sectorName }}, {{ "TICKETS.ROW" | translate }}: {{ cartItem.row }}, {{ "TICKETS.SEAT" | translate }}: {{ cartItem.seat }} </span>
            <div>
              <span class="info-price">{{ "TICKETS.PRICE" | translate }}:
                <ng-container *ngIf="cartItem.price !== cartItem.basePrice">
                  <span class="old-price">{{ cartItem.basePrice | number: '1.2-2'}} {{ cartItem.currency }}</span>
                </ng-container>
                 <b>{{ cartItem.price | number: '1.2-2'}} {{ cartItem.currency }}</b>
                </span>
              <button type="button" class="x-button" (click)="removeItemFromOrder(cartItem.id)">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <g opacity="0.27">
                    <path d="M11.7781 1.77295L7.42358 6.12646L12.4861 11.189L11.7791 11.896L6.71655 6.8335L1.65503 11.896L0.947998 11.189L6.00952 6.12646L1.65503 1.77295L2.36206 1.06592L6.71655 5.41943L11.071 1.06592L11.7781 1.77295Z" fill="black"/>
                    <path d="M11.7781 1.77295L11.9548 1.94975C12.0017 1.90286 12.0281 1.83927 12.0281 1.77296C12.0281 1.70665 12.0017 1.64306 11.9549 1.59617L11.7781 1.77295ZM7.42358 6.12646L7.24683 5.94967C7.19993 5.99655 7.17359 6.06014 7.17358 6.12645C7.17358 6.19276 7.19992 6.25635 7.24681 6.30324L7.42358 6.12646ZM12.4861 11.189L12.6629 11.3657C12.7605 11.2681 12.7605 11.1098 12.6629 11.0122L12.4861 11.189ZM11.7791 11.896L11.6023 12.0728C11.6999 12.1704 11.8582 12.1704 11.9558 12.0728L11.7791 11.896ZM6.71655 6.8335L6.89333 6.65672C6.84644 6.60983 6.78285 6.58349 6.71654 6.5835C6.65023 6.5835 6.58664 6.60984 6.53976 6.65674L6.71655 6.8335ZM1.65503 11.896L1.47825 12.0728C1.52514 12.1197 1.58873 12.146 1.65504 12.146C1.72135 12.146 1.78494 12.1196 1.83182 12.0728L1.65503 11.896ZM0.947998 11.189L0.771204 11.0122C0.673589 11.1098 0.673597 11.2681 0.771221 11.3657L0.947998 11.189ZM6.00952 6.12646L6.18632 6.30322C6.2332 6.25634 6.25953 6.19274 6.25952 6.12644C6.25951 6.06013 6.23317 5.99655 6.18628 5.94967L6.00952 6.12646ZM1.65503 1.77295L1.47825 1.59617C1.43137 1.64306 1.40503 1.70665 1.40503 1.77296C1.40503 1.83927 1.43138 1.90286 1.47827 1.94975L1.65503 1.77295ZM2.36206 1.06592L2.53882 0.889121C2.44118 0.791509 2.28291 0.791518 2.18528 0.889141L2.36206 1.06592ZM6.71655 5.41943L6.5398 5.59623C6.63742 5.69383 6.79568 5.69383 6.89331 5.59623L6.71655 5.41943ZM11.071 1.06592L11.2478 0.889141C11.1502 0.791518 10.9919 0.791509 10.8943 0.889121L11.071 1.06592ZM11.7781 1.77295L11.6013 1.59615L7.24683 5.94967L7.42358 6.12646L7.60034 6.30326L11.9548 1.94975L11.7781 1.77295ZM7.42358 6.12646L7.24681 6.30324L12.3093 11.3657L12.4861 11.189L12.6629 11.0122L7.60036 5.94969L7.42358 6.12646ZM12.4861 11.189L12.3093 11.0122L11.6023 11.7192L11.7791 11.896L11.9558 12.0728L12.6629 11.3657L12.4861 11.189ZM11.7791 11.896L11.9558 11.7192L6.89333 6.65672L6.71655 6.8335L6.53978 7.01027L11.6023 12.0728L11.7791 11.896ZM6.71655 6.8335L6.53976 6.65674L1.47824 11.7192L1.65503 11.896L1.83182 12.0728L6.89335 7.01026L6.71655 6.8335ZM1.65503 11.896L1.83181 11.7192L1.12477 11.0122L0.947998 11.189L0.771221 11.3657L1.47825 12.0728L1.65503 11.896ZM0.947998 11.189L1.12479 11.3657L6.18632 6.30322L6.00952 6.12646L5.83273 5.94971L0.771204 11.0122L0.947998 11.189ZM6.00952 6.12646L6.18628 5.94967L1.83179 1.59615L1.65503 1.77295L1.47827 1.94975L5.83276 6.30326L6.00952 6.12646ZM1.65503 1.77295L1.83181 1.94973L2.53884 1.24269L2.36206 1.06592L2.18528 0.889141L1.47825 1.59617L1.65503 1.77295ZM2.36206 1.06592L2.1853 1.24271L6.5398 5.59623L6.71655 5.41943L6.89331 5.24264L2.53882 0.889121L2.36206 1.06592ZM6.71655 5.41943L6.89331 5.59623L11.2478 1.24271L11.071 1.06592L10.8943 0.889121L6.5398 5.24264L6.71655 5.41943ZM11.071 1.06592L10.8943 1.24269L11.6013 1.94973L11.7781 1.77295L11.9549 1.59617L11.2478 0.889141L11.071 1.06592Z" fill="black"/>
                  </g>
                </svg>
              </button>
            </div>
          </div>

          <div class="container-checkbox w-100" *ngIf="appConfig.appHasMembership && !hideButtons && cart.items.length > 0 && hasPayment && !membersExclusive && !seasonTicketExclusive">
            <label>{{ "INPUTS.BARCODE_DISCOUNT" | translate }}
              <input type="checkbox" [checked]="showInputForMembershipBarcode[i]" (change)="checkHavingMembership($event, i)" (focus)="onClickInputField()">
              <span class="checkmark"></span>
            </label>
          </div>

          <div
            *ngIf="hasUserProfile()"
            class="container-checkbox prefill-container w-100"
            [class.disabled]="prefillSelectedItemId !== null && prefillSelectedItemId !== cartItem.id"
            [attr.title]="prefillSelectedItemId !== null && prefillSelectedItemId !== cartItem.id
                ? ('EVENT.PREFILL_DATA_DISABLED' | translate)
                : null"
          >
            <label>
              <input
                type="checkbox"
                (change)="onPrefillProfileData(cartItem.id, $event)"
                [checked]="prefillSelectedItemId === cartItem.id"
                [disabled]="prefillSelectedItemId !== null && prefillSelectedItemId !== cartItem.id"
              />
              <span class="checkmark"></span>
              {{ "EVENT.PREFILL_DATA" | translate }}
            </label>
          </div>

          <div class="barcode-container" *ngIf="appConfig.appHasMembership && showInputForMembershipBarcode[i]">
            <div class="user-form-input" [class.invalid]="userProfileForm.get(['items', i, 'membershipBarcode'])?.invalid && userProfileForm.get(['items', i, 'membershipBarcode'])?.touched">
              <label class="user-form-input-label" [for]="'barcode' + cartItem.id">{{ barcodeType }}</label>
              <input
                class="form-control"
                placeholder=" "
                type="number"
                [id]="'barcode' + cartItem.id"
                formControlName="membershipBarcode"
                (input)="onBarcodeInputImmediate($event, i)"
                (focus)="onClickInputField()"
              />
              <span class="error-message" *ngIf="(userProfileForm.get(['items', i, 'membershipBarcode'])?.touched && userProfileForm.get(['items', i, 'membershipBarcode'])?.invalid)">
                <ng-container *ngIf="userProfileForm.get(['items', i, 'membershipBarcode'])?.hasError('required')">
                  {{ "ERROR.BARCODE_EMPTY" | translate }}
                </ng-container>
                <ng-container *ngIf="userProfileForm.get(['items', i, 'membershipBarcode'])?.hasError('invalidBarcode')">
                  {{ "ERROR.BARCODE_INVALID" | translate }}
                </ng-container>
              </span>
            </div>
          </div>

          <ng-container
            *ngFor="let field of cartItem.profile.fields; let j = index"
           >
            <div
              class="user-form-input"
              [class.invalid]="userProfileForm.get(['items', i, field.name])?.invalid && userProfileForm.get(['items', i, field.name])?.touched"
              *ngIf="!membersExclusive && userProfileForm.get(['items', i, field.name])?.enabled"
              >
              <label class="user-form-input-label" [for]="field.name + '-' + cartItem.id">
                {{field.label}}
                <span *ngIf="field.name === 'dat_rodj'">({{ "COMMON.IN_FORMAT" | translate }})</span>
                <ng-container *ngIf="field.mandatory">*</ng-container>
              </label>

              <ng-container *ngIf="!field.lovItems || field.lovItems.length === 0; else choiceTemplate">
                <input
                  *ngIf="field.name !== 'dat_rodj'"
                  type="text"
                  [attr.data-sbr]="cartItem.id"
                  [attr.data-fieldNameWithCartId]="field.name+'-'+cartItem.id"
                  formControlName="{{field.name}}"
                  data-name="user-data"
                  class="form-control"
                  [id]="field.name + '-' + cartItem.id"
                  placeholder=" "
                  (focus)="onClickInputField()"
                />
                <input
                  *ngIf="field.name === 'dat_rodj'"
                  mask="00.00.0000"
                  [dropSpecialCharacters]="false"
                  type="text"
                  [attr.data-fieldNameWithCartId]="field.name+'-'+cartItem.id"
                  [attr.data-sbr]="cartItem.id"
                  formControlName="{{field.name}}"
                  data-name="user-data"
                  class="form-control"
                  [id]="field.name + '-' + cartItem.id"
                  placeholder=" "
                  (focus)="onClickInputField()"
                />

                <img *ngIf="userProfileForm.get(['items', i, field.name])?.disabled" src="img/lock.png" class="disabled-input-img" alt="Lock"/>
              </ng-container>

              <ng-template #choiceTemplate>
                <div class="form-control">
                  <select
                    class="dropdown"
                    [id]="field.name + '-' + cartItem.id"
                    [formControlName]="field.name"
                    (click)="onCountryChange($event, cartItem)"
                    data-name="{{field.name}}"
                    >
                    <option *ngFor="let lov of field.lovItems" [id]="lov.key + '-' + cartItem.id" [value]="lov.key">
                      {{ lov.value }}
                    </option>
                  </select>
                </div>
              </ng-template>
            </div>
          </ng-container>

          <div class="user-form-input members-exclusive-input" *ngIf="appConfig.appHasMembership && membersExclusive" [class.invalid]="userProfileForm.get(['items', i, 'membershipBarcode'])?.invalid && userProfileForm.get(['items', i, 'membershipBarcode'])?.touched">
            <div class="container-checkbox mb-4" *ngIf="i === 0 && membershipBarcode">
              <label>
                <input
                  type="checkbox"
                  (change)="prefillDataForProfileOwner($event, 'barcode' + cartItem.id)"
                />
                <span class="checkmark"></span>
                {{ "EVENT.PREFILL_DATA_WITH_MEMBERSHIP_BARCODE" | translate }}
              </label>
            </div>

            <label class="user-form-input-label" [for]="'barcode' + cartItem.id">{{ "MEMBERSHIP.CARD_BARCODE" | translate }}</label>
            <input
              data-name="user-data"
              [id]="'barcode' + cartItem.id"
              formControlName="membershipBarcode"
              placeholder=" "
              (focus)="onClickInputField()"
              type="number"
              (input)="onBarcodeInputImmediate($event, i)"
            />
            <span class="error-message" *ngIf="(userProfileForm.get(['items', i, 'membershipBarcode'])?.touched && userProfileForm.get(['items', i, 'membershipBarcode'])?.invalid)">
                <ng-container *ngIf="userProfileForm.get(['items', i, 'membershipBarcode'])?.hasError('required')">
                  {{ "ERROR.BARCODE_EMPTY" | translate }}
                </ng-container>
                <ng-container *ngIf="userProfileForm.get(['items', i, 'membershipBarcode'])?.hasError('invalidBarcode')">
                  {{ "ERROR.BARCODE_INVALID" | translate }}
                </ng-container>
              </span>
          </div>
          <span *ngIf="membersExclusive" class="membership-error-message" data-name="membership-error-message">{{ membershipErrorMessage }}</span>
        </div>
      </div>

      <form class="user-form form" [formGroup]="deliveryForm" *ngIf="showDeliverySubscriptionWithMember && !cart.isLocked && !showDelivery && !hideContinueButton">
        <div class="container-checkbox">
          <label for="deliverySameAs" class="user-form-input-label">{{ "EVENT.DELIVERY_SAME_AS_MEMBERSHIP_CARD" | translate }}
            <input
              type="checkbox"
              id="deliverySameAs"
              formControlName="deliverySameAs"
              (change)="setDeliveryWay()"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </form>

      <div class="cart-user-info w-100">
        <div class="container-checkbox" *ngIf="!hideButtons && cart.items.length > 0">
          <label>{{ "TERMS_OF_SALE.I_ACCEPT_SHORT" | translate }}
            <input type="checkbox" id="terms-of-sale" formControlName="termsOfSale" (change)="checkValue($event)" (focus)="onClickInputField()">
            <span class="checkmark"></span>
            <a href="{{redirectUrl}}/terms-of-sale" target="_blank"> {{ "TERMS_OF_SALE.TERMS_OF_SALE" | translate }} </a>
          </label>
        </div>
      </div>

      <app-cart-info-box [cart]="cart" *ngIf="cart"></app-cart-info-box>

      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
      <p class="error-message" *ngIf="errorDuplicatesMessage">{{ errorDuplicatesMessage }}</p>

      <ng-container *ngIf="showDelivery">
        <app-delivery [orderIdFromParent]="orderId" (emitShowPaymentOnModalForMembership)="emitOnSubmitDeliveryData()"></app-delivery>
      </ng-container>

      <div class="buttons-container" *ngIf="cart?.items?.length !== 0 && !hideContinueButton && !showDelivery">
        <button type="button" class="btn btn-default" (click)="cancelOrder()">{{ "COMMON.CANCEL" | translate }}</button>
        <button class="btn btn-primary" (click)="onSubmitNew()">{{ "COMMON.CONTINUE" | translate }}</button>
      </div>
    </form>

    <p class="success-message" *ngIf="showSuccessMessage">
      <span>{{ "TICKETS.PROCESS_FREE_TICKETS_MESSAGE" | translate }} </span>
      <a href="{{redirectUrl}}/user-profile">{{ "TICKETS.FROM_USER_PROFILE" | translate }}.</a>
    </p>
  </ng-container>
</div>
